/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListOrganicTrafficConfigsStatus200,
  ListOrganicTrafficConfigsStatus403,
  ListOrganicTrafficConfigsStatus500,
} from '../types/ListOrganicTrafficConfigs'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listOrganicTrafficConfigs } from '../clients/listOrganicTrafficConfigs'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listOrganicTrafficConfigsQueryKey = () =>
  [{ url: '/v1/bots/organic-traffic/config' }] as const

type ListOrganicTrafficConfigsQueryKey = ReturnType<typeof listOrganicTrafficConfigsQueryKey>

export function listOrganicTrafficConfigsQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listOrganicTrafficConfigsQueryKey()
  return queryOptions<
    ListOrganicTrafficConfigsStatus200,
    ResponseErrorConfig<ListOrganicTrafficConfigsStatus403 | ListOrganicTrafficConfigsStatus500>,
    ListOrganicTrafficConfigsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listOrganicTrafficConfigs({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Admin only. Lists every order book with a stored organic activity score configuration. Order books without one are scored with the bot service's own configuration and are not listed.
 * @summary List organic activity score configurations
 * {@link /v1/bots/organic-traffic/config}
 */
export function useListOrganicTrafficConfigs<
  TData = ListOrganicTrafficConfigsStatus200,
  TQueryData = ListOrganicTrafficConfigsStatus200,
  TQueryKey extends QueryKey = ListOrganicTrafficConfigsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListOrganicTrafficConfigsStatus200,
        ResponseErrorConfig<
          ListOrganicTrafficConfigsStatus403 | ListOrganicTrafficConfigsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listOrganicTrafficConfigsQueryKey()

  const queryResult = useQuery(
    {
      ...listOrganicTrafficConfigsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<ListOrganicTrafficConfigsStatus403 | ListOrganicTrafficConfigsStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
